import { Search2Icon } from '@chakra-ui/icons';
import { Input, InputGroup, InputRightElement, HStack } from '@chakra-ui/react';
import React, { useContext, useState } from 'react';
import { SearchContext } from './SearchContext';
import { AccountContext } from 'components/AccountContext';

function Searchbox({ placeholder }) {
  const { fetchSearch, lastSearch } = useContext(SearchContext);
  const [textSearch, setTextSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const { user } = useContext(AccountContext);
  const { id_contrato } = user;
  const sexo = user?.loggedIn ? (user.sexo === 'M' || user.sexo === 'm' ? 'M' : user.sexo === 'F' || user.sexo === 'f' ? 'F' : '') : null;
  const search = async () => {
    setLoading(true);
    if (textSearch !== lastSearch) fetchSearch(textSearch, 1, 10, sexo);
    setLoading(false);
  };

  return (
    <HStack>
      <InputGroup>
        <Input
          placeholder={placeholder || 'Pesquise aqui'}
          focusBorderColor="teal"
          bg={'#F0F0F0'}
          h={'3em'}
          borderRadius="0.8em"
          value={textSearch}
          onChange={(event) => setTextSearch(event.target.value)}
          onKeyPress={(event) => {
            if (event.key === 'Enter') {
              search();
            }
          }}
        />

        <InputRightElement width="15%" mt={1}>
          <Search2Icon color={'#5AB2AE'} onClick={search} />
        </InputRightElement>
      </InputGroup>
    </HStack>
  );
}

export default Searchbox;
